module.exports = __webpack_public_path__ + "img/answer1_incorrect.2ac58c04.png";